import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../../firebaseConfig";

export interface DeleteAccountResponse {
  status: string;
  message?: string;
}

export class AccountDeletionError extends Error {
  code?: string;

  constructor(message: string, code?: string) {
    super(message);
    this.name = "AccountDeletionError";
    this.code = code;
  }
}

export const deleteAccount = async (): Promise<DeleteAccountResponse> => {
  try {
    const functions = getFunctions(app, "us-central1");
    const callable = httpsCallable<unknown, DeleteAccountResponse>(
      functions,
      "deleteAccount"
    );
    const result = await callable();
    return result.data;
  } catch (error: any) {
    const code = error?.code ?? undefined;
    const message =
      typeof error?.message === "string"
        ? error.message
        : "Unable to delete account. Please try again.";
    throw new AccountDeletionError(message, code);
  }
};
